export default "__VITE_ASSET__c7691886__"